"use client"

import { BaseSyntheticEvent } from "react"
import clsx from "clsx"
import initialize from "initials"

type StreamChatAvatarProps = {
  image?: string | null
  name?: string
  size?: number
  shape?: "circle" | "rounded" | "square"
  className?: string
  onClick?: (event: BaseSyntheticEvent) => void
  onMouseOver?: (event: BaseSyntheticEvent) => void
}

export const StreamChatAvatar = ({
  image,
  name = "",
  size = 32,
  shape = "circle",
  className,
  onClick,
  onMouseOver,
}: StreamChatAvatarProps) => {
  const initials = initialize(name).toUpperCase()

  return (
    <div
      className={clsx(
        "str-chat__avatar",
        `str-chat__avatar--${shape}`,
        "str-chat__message-sender-avatar",
        className
      )}
      data-testid="avatar"
      onClick={onClick}
      onMouseOver={onMouseOver}
      style={{
        flexBasis: `${size}px`,
        height: `${size}px`,
        width: `${size}px`,
        lineHeight: `${size}px`,
        fontSize: `${size / 2}px`,
      }}
      title={name}
    >
      {image ? (
        <img
          alt={initials}
          className="str-chat__avatar-image str-chat__avatar-image--loaded"
          data-testid="avatar-img"
          src={image}
          style={{
            flexBasis: `${size}px`,
            height: `${size}px`,
            width: `${size}px`,
            objectFit: "cover",
            borderRadius: "50%",
          }}
        />
      ) : (
        <div
          className="flex items-center justify-center rounded-full bg-primary-50"
          style={{
            width: `${size}px`,
            height: `${size}px`,
          }}
        >
          <span
            className="text-gray-950 font-medium"
            style={{
              fontSize: `${size / 2.5}px`,
            }}
          >
            {initials}
          </span>
        </div>
      )}
    </div>
  )
}

